import React from 'react';
import actionContext from '../contexts/actions';
import { createPortal } from 'react-dom';
import { func, string } from 'prop-types';
import { filter } from 'rxjs';

const systemBackMessages = filter(
  (message) => message.event_type === 'system' && message.event_code === 'back',
);

export default class Fullscreen extends React.PureComponent {
  static contextType = actionContext;
  static propTypes = {
    onCloseRequest: func,
    mode: string,
  };
  static defaultProps = {
    onCloseRequest: Function.prototype,
    mode: 'player',
  };
  get actions() {
    return this.context;
  }

  constructor(props) {
    super(props);
    this.portal = document.querySelector(props.portal);
  }
  componentDidMount() {
    /*
        const names = React.Children.map(this.props.children, (chidlren) => {
          return chidlren?.type?.type?.name;
        });
        console.log('Mount fullscreen wrapper', names);
    */
    this.actions.hostApp.requestForeground({
      onCloseRequest: this.props.onCloseRequest,
      mode: this.props.mode,
    });
    this.subscription = this.actions.hostApp.message$
      .pipe(systemBackMessages)
      .subscribe(() => {
        this.props.onCloseRequest();
      });
  }

  componentWillUnmount() {
    /*
        console.log('Unmount fullscreen wrapper', this.props.children.type.type.name);
    */
    this.actions.hostApp.releaseForeground();
    this.subscription?.unsubscribe();
  }

  render() {
    return this.portal
      ? createPortal(this.props.children, this.portal)
      : this.props.children;
  }
}
